const SIMPLE_CREDIT_CARD_COLUMN_TYPES = Object.freeze({
    welcomeBonus: 'welcome-bonus',
    rewardEarningRates: 'reward-earning-rates',
    custom: 'custom',
});

const OPTION_LABELS = {
    [SIMPLE_CREDIT_CARD_COLUMN_TYPES.welcomeBonus]: 'Welcome bonus',
    [SIMPLE_CREDIT_CARD_COLUMN_TYPES.rewardEarningRates]: 'Reward earning rates',
    [SIMPLE_CREDIT_CARD_COLUMN_TYPES.custom]: 'Custom',
};

const SIMPLE_CREDIT_CARD_COLUMN_TYPES_OPTIONS = Object.values(SIMPLE_CREDIT_CARD_COLUMN_TYPES).map(value => ({
    value: value,
    label: OPTION_LABELS[value],
}));


export { SIMPLE_CREDIT_CARD_COLUMN_TYPES };
export default SIMPLE_CREDIT_CARD_COLUMN_TYPES_OPTIONS;
